module.exports = __webpack_public_path__ + "static/media/bindQQ2.ad88f853.png";